import { WarehousePreparationView } from "./warehouse/WarehousePreparationView";
import { useWarehousePreparationWorkspace } from "./warehouse/useWarehousePreparationWorkspace";
import type { WarehousePreparationProps } from "./warehouse/useWarehousePreparationWorkspace";
import "./WarehousePreparationModule.css";
export function WarehousePreparationModule(props: WarehousePreparationProps) {
 const workspace = useWarehousePreparationWorkspace(props);
 return <WarehousePreparationView {...props} workspace={workspace} />;
}
